import { useDismissMessageMutation } from "api/apiSlice";
import { IMessage, messageDeExer } from "api/apiTypes";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import "global.css";

interface NewMembersProps {
  message: IMessage;
}

export const NewMembers = (props: NewMembersProps) => {
  const { message } = props;
  const [dismissMessage] = useDismissMessageMutation();

  const onDismissClicked = async (messageId: string) => {
    dismissMessage(messageId);
  };

  return (
    <Card className="mb-3">
      <Card.Header>
        <Image
          alt="Author avatar"
          roundedCircle
          className="me-2"
          src={message.authorUrl}
        />
        <span className="nerdle-author-name align-middle">
          {message.author}
        </span>
        {message.badgeUrl && (
          <Image roundedCircle className="ms-1" src={message.badgeUrl} />
        )}
      </Card.Header>
      <Card.Body>
        <Card.Text>{messageDeExer(message.messageEx)}</Card.Text>
        <Card.Text className="text-secondary mb-0">{message.streamName} Stream</Card.Text>
        <Card.Text className="text-secondary">{message.datetime}</Card.Text>
        <Button
          onClick={() => onDismissClicked(message.messageId)}
          variant="primary"
        >
          Dismiss
        </Button>
      </Card.Body>
    </Card>
  );
};
